/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Icon } from '@az/starc-ui';
import { ChevronRight } from '@az/starc-ui-icons';
import styles from './CarouselArrows.module.scss';
import { useLabels } from '@/hooks/useLabels';

type Props = {
  onPrev: () => void;
  onNext: () => void;
  isVisible: boolean;
};

const labelMap = {
  leftArrowLabel: 'label_reviews_customerImagesModal_prev',
  rightArrowLabel: 'label_reviews_customerImagesModal_next',
};

const CarouselArrows = ({ onPrev, onNext, isVisible }: Props) => {
  const buttonClass = `${styles.Arrow} ${isVisible ? styles.Visible : ''}`;
  const labels = useLabels(labelMap);

  return (
    <div className={styles.ArrowsWrapper}>
      <button
        type="button"
        className={`${buttonClass} ${styles.Prev}`}
        aria-label={labels.leftArrowLabel}
        onClick={onPrev}
      >
        {/* Mirrored ChevronRight serves as left arrow */}
        <span className={styles.FlippedIcon}>
          <Icon svg={ChevronRight} attributes={{ style: { width: 24, height: 24 } }} />
        </span>
      </button>
      <button
        type="button"
        className={`${buttonClass} ${styles.Next}`}
        aria-label={labels.rightArrowLabel}
        onClick={onNext}
      >
        <Icon svg={ChevronRight} attributes={{ style: { width: 24, height: 24 } }} />
      </button>
    </div>
  );
};

export default CarouselArrows;
